import { useContext } from 'react';
import { AuthContext } from './context/AuthContext';
import { isTokenExpired } from './utils/dateHelpers';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, adminOnly }) {
  const { user, consentRequired } = useContext(AuthContext);
  const token = localStorage.getItem('token');

  if (!token || isTokenExpired(token)) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }
  if (consentRequired) {
    return <Navigate to="/consent-required" />;
  }
  if (!user) {
    return <Navigate to="/login" />;
  }
  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/" />;
  }
  return children;
}

export default ProtectedRoute;